document.addEventListener('DOMContentLoaded', () => {
  const generatePdfButton = document.querySelector('#generate-pdf-link');
  const pdfProcessingModal = document.querySelector('#pdfProcessingModal');
  const acceptModalButton = document.querySelector('#acceptModal');
  let isProcessing = false;
  
  const logInfo = (message, data = null) => {
    console.log(`[PDF Generator] ${message}`, data || '');
    // Füge hier eine Funktion hinzu, um Logs an den Server zu senden
    sendLogToServer(message, data);
  };

  // Funktion zum Senden von Logs an den Server
  async function sendLogToServer(message, data = null) {
    try {
      const formData = new FormData();
      formData.append('logType', 'frontend');
      formData.append('message', message);
      formData.append('data', JSON.stringify(data));
      formData.append('userAgent', navigator.userAgent);
      formData.append('timestamp', new Date().toISOString());
      
      await fetch('https://baurelia.mainwebsite.ch/uploadpdf/log-events.php', {
        method: 'POST',
        body: formData
      });
    } catch (error) {
      console.error('Fehler beim Senden des Logs:', error);
    }
  }

  // Create an overlay for blocking user interactions
  const overlay = document.createElement('div');
  overlay.id = 'interaction-blocker';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(0, 0, 0, 0)';
  overlay.style.zIndex = '99999';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);

  // Check interactions on specific elements
  const interactiveElements = ['.text-styling__personalizer-item', '.mw-r_button', '.mw-wunschtext-field', '.color-picker__item', '.image-swatch'];

  logInfo('PDF Generator initialisiert');

  interactiveElements.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.addEventListener('click', () => {
        logInfo(`Element geklickt: ${selector}`);
        enableGeneratePdfButton();
      });
    });

    // Observe dynamically added elements
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.matches && node.matches(selector)) {
              node.addEventListener('click', () => {
                logInfo(`Dynamisch hinzugefügtes Element geklickt: ${selector}`);
                enableGeneratePdfButton();
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });

  function enableGeneratePdfButton() {
    if (generatePdfButton) {
      if (window.BaureliaCustomizerCatalog?.canSubmit?.() === false) {
        generatePdfButton.disabled = true;
        generatePdfButton.setAttribute('aria-disabled', 'true');
        generatePdfButton.style.pointerEvents = 'none';
        return;
      }
      generatePdfButton.disabled = false;
      generatePdfButton.setAttribute('aria-disabled', 'false');
      generatePdfButton.style.pointerEvents = 'auto';
      generatePdfButton.style.backgroundColor = '';
      generatePdfButton.style.color = '';
      generatePdfButton.style.cursor = 'pointer';
      logInfo('PDF-Button aktiviert');
    } else {
      logInfo('PDF-Button nicht gefunden bei Aktivierungsversuch');
    }
  }

  // Function to show confirmation modal
  function showConfirmationModal() {
    if (pdfProcessingModal) {
      pdfProcessingModal.classList.add('open');
      document.body.classList.add('overflow-hidden');
      logInfo('Bestätigungsmodal geöffnet und Body-Scroll deaktiviert');
    } else {
      logInfo('Bestätigungsmodal nicht gefunden');
    }
  }

  // Function to hide confirmation modal
  function hideConfirmationModal() {
    if (pdfProcessingModal) {
      pdfProcessingModal.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
      logInfo('Bestätigungsmodal geschlossen und Body-Scroll aktiviert');
    }
  }

  // Function to ensure all images are loaded
  function ensureImagesLoaded(node) {
    const images = node.querySelectorAll('img');
    logInfo(`Warte auf ${images.length} Bilder zum Laden`);
    
    const promises = Array.from(images).map((img, index) => {
      if (img.complete && img.naturalWidth > 0) {
        logInfo(`Bild ${index + 1}/${images.length} bereits geladen`);
        return Promise.resolve();
      }
      if (img.complete && img.src) {
        return Promise.reject(new Error(`Bild konnte nicht geladen werden: ${img.src}`));
      }
      return new Promise((resolve, reject) => {
        const timeout = window.setTimeout(() => {
          reject(new Error(`Zeitüberschreitung beim Laden eines Vorschaubildes: ${img.src}`));
        }, 20000);
        img.addEventListener('load', () => {
          window.clearTimeout(timeout);
          logInfo(`Bild ${index + 1}/${images.length} erfolgreich geladen`);
          resolve();
        }, { once: true });
        img.addEventListener('error', () => {
          window.clearTimeout(timeout);
          logInfo(`Fehler beim Laden von Bild ${index + 1}/${images.length}`, {
            src: img.src,
            width: img.width,
            height: img.height
          });
          reject(new Error(`Bild konnte nicht geladen werden: ${img.src}`));
        }, { once: true });
      });
    });
    return Promise.all(promises);
  }

  function withTimeout(promise, milliseconds, message) {
    let timeout;
    return Promise.race([
      promise,
      new Promise((_, reject) => {
        timeout = window.setTimeout(() => reject(new Error(message)), milliseconds);
      })
    ]).finally(() => window.clearTimeout(timeout));
  }

  async function verifyCustomizerReady() {
    const form = generatePdfButton?.closest('form');
    if (!form) throw new Error('Produktformular wurde nicht gefunden.');
    if (!form.reportValidity()) throw new Error('Bitte fülle alle Pflichtfelder aus.');

    const motifRequired = Boolean(form.querySelector('[data-baurelia-motifs]'));
    if (motifRequired && !window.BaureliaCustomizerCatalog?.ensureMotifReady) {
      throw new Error('Die Motivverwaltung konnte nicht geladen werden. Bitte lade die Seite neu.');
    }
    const selection = await window.BaureliaCustomizerCatalog?.ensureMotifReady?.();
    if (motifRequired && !selection) {
      throw new Error('Das ausgewählte Motiv ist noch nicht vollständig geladen.');
    }
    if (selection) {
      const motifId = document.getElementById('baurelia-motif-id')?.value;
      const motifImage = document.getElementById('baurelia-motif-image')?.value;
      if (motifId !== selection.id || motifImage !== selection.imageUrl) {
        throw new Error('Motivauswahl und Vorschau stimmen nicht überein.');
      }
    }

    if (typeof window.updatePreviewUrl === 'function') window.updatePreviewUrl();
    const pdfInput = document.getElementById('pdf_link');
    if (!pdfInput) throw new Error('PDF-Feld wurde nicht gefunden.');
    pdfInput.value = '';
    return { form, selection };
  }

  function submitProductForm(form) {
    const addToCartButton = form.querySelector('button[type="submit"][name="add"]');
    if (!addToCartButton || addToCartButton.disabled) {
      throw new Error('Warenkorb-Button ist nicht verfügbar.');
    }
    if (!document.getElementById('pdf_link')?.value) {
      throw new Error('PDF wurde nicht erfolgreich gespeichert.');
    }
    form.requestSubmit(addToCartButton);
  }

  function restoreImageStyles(items) {
    items.forEach(item => {
      item.element.style.position = item.position;
      item.element.style.left = item.left;
      item.element.style.top = item.top;
      item.element.style.width = item.width;
      item.element.style.height = item.height;
      item.element.style.transform = item.transform;
      item.element.style.margin = item.margin;
      item.element.style.zIndex = item.zIndex;
    });
  }

  function closeCustomizerAfterSuccess() {
    document.querySelector('.gallery-preview')?.classList.remove('active');
    document.querySelector('.preview-settings_overlay')?.classList.remove('visible');
    document.body.classList.remove('active');
    document.querySelector('.tab_mobile-header')?.classList.add('active');
    document.querySelector('.preview-settings')?.classList.add('p-hidden');
    document.querySelector('#mobile_trigger')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  async function generatePdf() {
    logInfo("PDF-Generierung nach Bestätigung gestartet");
    const spinner = document.createElement('span');
    const originalStyles = [];
    let completed = false;
    spinner.className = 'spinner';
    generatePdfButton.appendChild(spinner);
    generatePdfButton.disabled = true;
    generatePdfButton.setAttribute('aria-disabled', 'true');
    generatePdfButton.style.cursor = 'not-allowed';
    generatePdfButton.style.pointerEvents = 'none';
    overlay.style.display = 'block';

    try {
      const { form, selection } = await verifyCustomizerReady();
      const node = document.querySelector('#print_pdf');
      if (!node) throw new Error('Vorschaubereich für PDF wurde nicht gefunden.');
      if (!window.domtoimage || !window.jspdf?.jsPDF) {
        throw new Error('PDF-Komponenten konnten nicht geladen werden.');
      }
      if (!Number.isFinite(pdfInchesWidth) || !Number.isFinite(pdfInchesHeight)) {
        throw new Error('PDF-Abmessungen sind ungültig.');
      }

      await ensureImagesLoaded(node);
      const scale = 9;
      const width = node.clientWidth * scale;
      const height = node.clientHeight * scale;
      if (!width || !height) throw new Error('Die Druckvorschau hat keine gültige Größe.');

      node.querySelectorAll('img').forEach(img => {
        const computedStyle = window.getComputedStyle(img);
        const rect = img.getBoundingClientRect();
        originalStyles.push({
          element: img,
          position: img.style.position,
          left: img.style.left,
          top: img.style.top,
          width: img.style.width,
          height: img.style.height,
          transform: img.style.transform,
          margin: img.style.margin,
          zIndex: img.style.zIndex
        });
        img.style.position = 'fixed';
        img.style.left = `${rect.left}px`;
        img.style.top = `${rect.top}px`;
        img.style.width = `${rect.width}px`;
        img.style.height = `${rect.height}px`;
        img.style.transform = 'none';
        img.style.margin = '0';
        img.style.zIndex = computedStyle.zIndex;
      });

      overlay.style.display = 'none';
      node.offsetHeight;
      const dataUrl = await withTimeout(
        window.domtoimage.toPng(node, {
          width,
          height,
          quality: 1,
          style: {
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            'font-smoothing': 'antialiased'
          }
        }),
        60000,
        'Die Erstellung der Druckvorschau hat zu lange gedauert.'
      );
      restoreImageStyles(originalStyles);
      originalStyles.length = 0;
      overlay.style.display = 'block';

      const image = await new Promise((resolve, reject) => {
        const rendered = new Image();
        rendered.onload = () => resolve(rendered);
        rendered.onerror = () => reject(new Error('PDF-Vorschaubild konnte nicht erzeugt werden.'));
        rendered.src = dataUrl;
      });

      const PDF_POINTS_WIDTH = pdfInchesWidth * 72;
      const PDF_POINTS_HEIGHT = pdfInchesHeight * 72;
      const pdf = new window.jspdf.jsPDF({
        orientation: pdfOrientation,
        unit: 'pt',
        format: [PDF_POINTS_WIDTH, PDF_POINTS_HEIGHT]
      });
      const imageAspectRatio = image.width / image.height;
      const pdfAspectRatio = PDF_POINTS_WIDTH / PDF_POINTS_HEIGHT;
      const finalImgWidth = imageAspectRatio > pdfAspectRatio
        ? PDF_POINTS_WIDTH
        : PDF_POINTS_HEIGHT * imageAspectRatio;
      const finalImgHeight = imageAspectRatio > pdfAspectRatio
        ? PDF_POINTS_WIDTH / imageAspectRatio
        : PDF_POINTS_HEIGHT;
      const xOffset = (PDF_POINTS_WIDTH - finalImgWidth) / 2;
      const yOffset = (PDF_POINTS_HEIGHT - finalImgHeight) / 2;
      pdf.addImage(dataUrl, 'PNG', xOffset, yOffset, finalImgWidth, finalImgHeight, undefined, 'FAST');

      const identity = String(selection?.handle || selection?.slug || 'custom')
        .replace(/[^a-z0-9-]/gi, '-')
        .slice(0, 60);
      const fileName = `Order_${generateRandomId(16)}_${identity}.pdf`;
      const pdfBlob = pdf.output('blob');
      if (!pdfBlob.size) throw new Error('Die erzeugte PDF ist leer.');
      await sendToServer(pdfBlob, fileName);
      completed = true;
      return form;
    } catch (error) {
      logInfo('Fehler bei der PDF-Generierung', {
        error: error.message || 'Unbekannter Fehler',
        stack: error.stack
      });
      console.error('Error generating PDF:', error);
      alert(error.message || 'Bei der Generierung des PDFs ist ein Fehler aufgetreten. Bitte versuche es erneut.');
      return null;
    } finally {
      restoreImageStyles(originalStyles);
      spinner.remove();
      overlay.style.display = 'none';
      if (!completed) enableGeneratePdfButton();
      logInfo("PDF-Generierung abgeschlossen", { completed });
    }
  }

  if (generatePdfButton) {
    logInfo('PDF-Button gefunden und Event-Listener hinzugefügt');
    
    // Generate PDF button click event - now shows modal first
    generatePdfButton.addEventListener('click', async (event) => {
      logInfo("PDF-Button wurde geklickt - zeige Bestätigungsmodal");
      event.preventDefault();
      event.stopPropagation();
      
      // Show confirmation modal instead of directly generating PDF
      showConfirmationModal();
    });
  } else {
    logInfo('PDF-Button nicht gefunden');
    console.error('Generate PDF button not found.');
  }

  // Accept button click event
  if (acceptModalButton) {
    acceptModalButton.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (isProcessing) return;
      isProcessing = true;
      logInfo("Bestätigung erhalten - starte PDF-Generierung");
      hideConfirmationModal();

      try {
        const form = await generatePdf();
        if (!form) return;
        closeCustomizerAfterSuccess();
        submitProductForm(form);
      } catch (error) {
        logInfo('Bestellung konnte nicht abgeschlossen werden', {
          error: error.message,
          stack: error.stack
        });
        console.error('Bestellung konnte nicht abgeschlossen werden:', error);
        alert(error.message || 'Die Bestellung konnte nicht abgeschlossen werden. Bitte versuche es erneut.');
        enableGeneratePdfButton();
      } finally {
        isProcessing = false;
      }
    });
    logInfo('Accept-Button Event-Listener hinzugefügt');
  } else {
    logInfo('Accept-Button nicht gefunden');
    console.error('Accept modal button not found.');
  }

  // Optional: Close modal when clicking outside of it
  if (pdfProcessingModal) {
    pdfProcessingModal.addEventListener('click', (event) => {
      if (event.target === pdfProcessingModal) {
        logInfo("Modal durch Außenklick geschlossen");
        hideConfirmationModal();
      }
    });
  }

  function generateRandomId(length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    return Array.from({ length }, () => characters.charAt(Math.floor(Math.random() * characters.length))).join('');
  }

  async function sendToServer(pdfBlob, fileName) {
    logInfo("Starte Upload zum Server", { fileName });
    
    const formData = new FormData();
    formData.append('pdfFile', pdfBlob, fileName);
    formData.append('clientInfo', JSON.stringify({
      userAgent: navigator.userAgent,
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      timestamp: new Date().toISOString(),
      motifId: document.getElementById('baurelia-motif-id')?.value || null,
      motifHandle: document.getElementById('baurelia-motif-handle')?.value || null,
      motifSlug: document.getElementById('baurelia-motif-slug')?.value || null
    }));

    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 60000);
    try {
      const uploadStart = performance.now();
      const response = await fetch('https://baurelia.mainwebsite.ch/uploadpdf/improved-upload-pdf.php', {
        method: 'POST',
        body: formData,
        signal: controller.signal,
      });
      const uploadEnd = performance.now();
      logInfo(`Server-Upload abgeschlossen in ${(uploadEnd - uploadStart).toFixed(2)}ms`);
      
      if (!response.ok) {
        const errorText = await response.text();
        logInfo('Server-Fehler', { 
          status: response.status,
          statusText: response.statusText,
          responseText: errorText
        });
        throw new Error(`PDF-Upload fehlgeschlagen (HTTP ${response.status}).`);
      }

      const data = await response.json();
      logInfo('Server-Antwort', data);
      if (!data?.file_path) throw new Error('PDF-URL fehlt in der Server-Antwort.');
      const pdfUrl = `https://baurelia.mainwebsite.ch/uploadpdf${data.file_path}`;
      setPdfInputValue(pdfUrl);
      return pdfUrl;
    } catch (error) {
      logInfo('Netzwerkfehler beim Upload', { error: error.message, stack: error.stack });
      console.error('Network error:', error);
      if (error.name === 'AbortError') {
        throw new Error('Der PDF-Upload hat zu lange gedauert. Bitte versuche es erneut.');
      }
      throw error;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function setPdfInputValue(pdfUrl) {
    const pdfInput = document.getElementById('pdf_link');
    if (pdfInput) {
      pdfInput.value = pdfUrl;
      logInfo('PDF-Link im Input-Feld gesetzt');
    } else {
      throw new Error('PDF-Feld wurde nicht gefunden.');
    }

    if (generatePdfButton) {
      generatePdfButton.disabled = true;
      generatePdfButton.setAttribute('aria-disabled', 'true');
      generatePdfButton.style.pointerEvents = 'none';
      generatePdfButton.style.backgroundColor = '#cccccc';
      generatePdfButton.style.color = '#ffffff';
      generatePdfButton.style.cursor = 'not-allowed';
      logInfo('PDF-Button deaktiviert nach erfolgreicher Generierung');
    }
  }
});
